import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { colors } from "@/theme/colors";

type Props = {
  agreed: boolean;
  onAgreedChange: (value: boolean) => void;
};

/**
 * キャンセル前の確認事項 + 同意チェックボックス。
 * チェックボックスのラベルは同意文のみとし、その下に別枠でキャンセル前の確認事項
 * (元に戻せない旨・返金方法) を表示する (JPTP_CANSEI-1269 の表示内容に準拠)。
 */
export function CancelAgreementSection({ agreed, onAgreedChange }: Props) {
  const { t } = useTranslation();

  return (
    <Box>
      <FormControlLabel
        sx={{ alignItems: "flex-start" }}
        control={
          <Checkbox
            checked={agreed}
            onChange={(e) => onAgreedChange(e.target.checked)}
            color="secondary"
            sx={{ pt: 0 }}
          />
        }
        label={t("cancelReservation.agreementLabel")}
      />
      <Box sx={{ bgcolor: colors.surfaceMuted, borderRadius: 2, p: 2, mt: 1 }}>
        <Typography sx={{ color: colors.textBody, fontSize: 14, fontWeight: 600, mb: 0.5, pl: 2 }}>
          {t("cancelReservation.confirmNoticeTitle")}
        </Typography>
        <List sx={{ listStyleType: "disc", pl: 5 }} disablePadding>
          <ListItem sx={{ display: "list-item", p: 0 }}>
            <Typography sx={{ color: colors.textBody, fontSize: 14 }}>
              {t("cancelReservation.confirmNoticeIrreversible")}
            </Typography>
          </ListItem>
          <ListItem sx={{ display: "list-item", p: 0 }}>
            <Typography sx={{ color: colors.textBody, fontSize: 14 }}>
              {t("cancelReservation.confirmNoticeRefund")}
            </Typography>
          </ListItem>
        </List>
      </Box>
    </Box>
  );
}
